export default __webpack_public_path__ + "static/media/img-gt-mode-on-bg-at_de.d3fc299a.jpg";